import { defineMessages } from 'react-intl';

export default defineMessages({
    sumpPumpType: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHODwellingProtectionDetails.WMICWaterMitigationDetails.WMICWaterMitigationDetails.sumpPumpType',
        defaultMessage: 'Sump Pump Type',
    },
    sumpPumpAuxiliaryPower: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHODwellingProtectionDetails.WMICWaterMitigationDetails.WMICWaterMitigationDetails.sumpPumpAuxiliaryPower',
        defaultMessage: 'Backup Power Supply',
    },
    backupValve: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHODwellingProtectionDetails.WMICWaterMitigationDetails.WMICWaterMitigationDetails.backupValve',
        defaultMessage: 'Backup/Backflow Valve',
    },
    mainWaterShutOffType: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHODwellingProtectionDetails.WMICWaterMitigationDetails.WMICWaterMitigationDetails.mainWaterShutOffType',
        defaultMessage: 'Main Water Valve Shut Off Type',
    },
    numberOfWaterShutOffSensors: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHODwellingProtectionDetails.WMICWaterMitigationDetails.WMICWaterMitigationDetails.numberOfWaterShutOffSensors',
        defaultMessage: 'Number of Main Water Valve Shut Off Sensors',
    },
    description: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHODwellingProtectionDetails.WMICWaterMitigationDetails.WMICWaterMitigationDetails.Description',
        defaultMessage: 'Description',
    },
});
